import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PgsSelectSearchDropdownComponent } from './components/pgs-select-search-dropdown.component';
import { PgsSelectSearchComponent } from './components/pgs-select-search.component';
export { PgsSelectSearchComponent } from './components/pgs-select-search.component';
export { IOption } from './types/option.interface';


@NgModule({
  declarations: [
    PgsSelectSearchComponent,
    PgsSelectSearchDropdownComponent
  ],
  exports: [
    PgsSelectSearchComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class PgsSelectSearchModule { }
